// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from 'prop-types';

// Data
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

// Components
import ExploringMap from "nextus/Maps/ExploringMaps/Groups";
import MapNav from "nextus/Sidenavs/MapNav";

// API/MODELS
import groupAPI from "api/groups";
import bksAPI from "api/bks";
import clearwaysAPI from "modules/clearways/api";
import userAPI from 'api/user';

// Mapbox
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';

// helper
import { processDevicesData } from "helper/device";
import MapMenuContent from "nextus/MapMenuContent";
import { processGroupData } from "helper/group";
import { useMatch } from "react-router-dom";
import { processEventsData } from "helper/event";
import { useSoftUIController } from "context";

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function wrapper(map, content) {
    return (
        <SoftBox sx={{ width: '100%', height: '100%' }}>
            {map}
            {content}
        </SoftBox>
    )
}

function ExploreMap({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) {
    groupAPI.loadToken(useAuth0());
    bksAPI.loadToken(useAuth0());
    clearwaysAPI.loadToken(useAuth0());
    userAPI.loadToken(useAuth0());

    const { user } = useAuth0();

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [menuToggled, setMenuToggled] = useState(true);
    const [mapPadding, setMapPadding] = useState([600, 250]);
    const [groupPreviewID, setGroupPreviewID] = useState(0);

    const [controller, dispatch] = useSoftUIController();
    const { miniSidenav, hiddenSidenav, direction, layout, openConfigurator, sidenavColor, deviceStyle } = controller;

    const [eventbarState, setEventbarState] = useState('closed');

    // console.log(group_ids);

    const groups = useQuery({
        queryKey: ['getAllGroups'],
        queryFn: async () => {
            return await groupAPI.getAllGroups();
        }
    });

    const devices = useQuery({
        queryKey: ['getAllDevices'],
        queryFn: async () => {
            return await bksAPI.getAllDevices()
        }
    });

    const events = useQuery({
        queryKey: ['getAllClearways'],
        queryFn: async () => {
            return await clearwaysAPI.getAllClearways();
        },
        // staleTime: 20 * 1000
    });

    const selected_user = useQuery({
        queryKey: ['getUserByEmail', user.email.toLowerCase()],
        queryFn: async () => {
            return await userAPI.getUserByEmail(user.email.toLowerCase());
        }
    });

    useEffect(() => {
        // console.log('explore_map')
        setSidebarState('exploring');
        setNavTitle(['explore map']);

        if (deviceStyle == 'mobile') {
            setMapPadding([0, 0]);
            // setSidebarOpen(false);
        }
        else {
            if (!sidebarOpen) {
                if (eventbarState == 'open') {
                    setMapPadding([0, 250]);
                }
                else {
                    setMapPadding([0, 0]);
                }
                setSidebarOpen(false);
            }
            else {
                if (eventbarState == 'open') {
                    setMapPadding([600, 250]);
                }
                else {
                    setMapPadding([600, 0]);
                }
                setSidebarOpen(true);
            }
        }

    }, [sidebarOpen, navTitle, deviceStyle]);

    if (groups.isLoading || devices.isLoading || events.isLoading || selected_user.isLoading) {
        return wrapper('Loading...', 'Loading...');
    }

    if (groups.error || devices.error || events.error || selected_user.error) {
        if (groups.error) {
            var error = groups.error;
        }
        else if (devices.error) {
            var error = devices.error;
        }
        else if (events.error) {
            var error = events.error;
        }
        else {
            var error = selected_user.error;
        }
        return wrapper("An error has occurred: " + error.message);
    }

    if (!groups.data || !devices.data || !selected_user.data) {
        return wrapper('Loading...');
    }

    // if (events.isLoading) {
    // return wrapper((<ExploringMap map={map} mapPadding={mapPadding} extraPadding={eventbarState == 'open'} groups_data={groups_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} deviceStyle={deviceStyle} />), ('Loading...'));
    // }

    // if (events.error) {
    //     return wrapper((<ExploringMap map={map} mapPadding={mapPadding} extraPadding={eventbarState == 'open'} groups_data={groups_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} />), ("An error has occurred: " + events.error.message));
    // }

    // if (!events.data) {
    //     return wrapper((<ExploringMap map={map} mapPadding={mapPadding} extraPadding={eventbarState == 'open'} groups_data={groups_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} />), ('Loading...'));
    // }

    var events_data = processEventsData(events.data);

    var groups_data = groups.data.filter((row) => row.type == "clearways").map(function (group) {
        var ret = processGroupData(group, devices.data, selected_user.data.user.user_type);
        return ret;
    }).filter(group => typeof group.parent_id == 'undefined');

    return wrapper(
        (<ExploringMap map={map} mapPadding={mapPadding} extraPadding={events_data.length > 0} user_role={selected_user.data.user.user_type} groups_data={groups_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} deviceStyle={deviceStyle} />),
        (<MapMenuContent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} groupPreviewID={groupPreviewID} sidebarState={'exploring'} events={events_data} eventbarState={events_data.length > 0 ? 'open' : 'closed'} setEventbarState={setEventbarState} deviceStyle={deviceStyle} />)
    );
}

ExploreMap.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default ExploreMap;